import React from 'react';
import { Search, Loader2, X } from 'lucide-react';

const PagoSearch = ({ searchTerm, setSearchTerm, handleSearch, loading }) => {

    // Debounce Effect: cuando el usuario escribe, espera 500ms
    React.useEffect(() => {
        const timeoutId = setTimeout(() => {
            handleSearch(searchTerm);
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [searchTerm, handleSearch]);

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSearch(searchTerm);
    };

    const handleClear = () => {
        setSearchTerm('');
        handleSearch('');
    };

    return (
        <form onSubmit={handleSubmit} className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 mb-6 flex items-center">
            <Search className="w-5 h-5 text-gray-400 mr-3 shrink-0" />
            <input 
                type="text" 
                placeholder="Buscar por Código de Medidor (ej: 122), Cédula o Nombre..."
                className="flex-1 outline-none text-gray-600 placeholder-gray-400"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            {loading && <Loader2 className="w-5 h-5 text-blue-500 animate-spin ml-2 shrink-0" />}
            {searchTerm && !loading && (
                <button
                    type="button"
                    onClick={handleClear}
                    className="p-1 hover:bg-gray-100 rounded-full text-gray-400 hover:text-gray-600 transition-colors ml-2"
                    title="Limpiar búsqueda"
                >
                    <X className="w-4 h-4" />
                </button>
            )}
        </form>
    );
};

export default PagoSearch;
